import { useState, useCallback } from "react";
import { api } from "../services/apiClient";

export const useAdminDashboard = () => {
  const [adminStats, setAdminStats] = useState(null);
  const [adminUsers, setAdminUsers] = useState([]);

  const fetchAdminStats = useCallback(async () => {
    try {
      const r = await api.get("/admin/stats");
      if (r.ok) {
        const data = await r.json();
        const plans = data?.plans || {};
        const paidUsers = Object.entries(plans).reduce((sum, [plan, count]) => {
          if (plan === "free") return sum;
          return sum + (Number(count) || 0);
        }, 0);

        setAdminStats({
          ...data,
          paid_users: data?.paid_users ?? paidUsers,
          users_by_role: data?.users_by_role ?? data?.roles ?? {},
        });
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const fetchAdminUsers = useCallback(async () => {
    try {
      const r = await api.get("/admin/users");
      if (r.ok) {
        const data = await r.json();
        setAdminUsers(Array.isArray(data) ? data : data?.users || []);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const fetchAll = useCallback(async () => {
    await Promise.all([fetchAdminStats(), fetchAdminUsers()]);
  }, [fetchAdminStats, fetchAdminUsers]);

  return {
    adminStats,
    adminUsers,
    fetchAdminStats,
    fetchAdminUsers,
    fetchAll,
  };
};
